import HttpClient from "../helpers/HttpClient"
import Reminder, { ReminderDto } from "./Reminder"
import { HttpError, isError } from "../helpers/Error"


class ReminderService {
    httpClient: HttpClient<Reminder, ReminderDto> = new HttpClient<Reminder, ReminderDto>(Reminder)

    async Get(accountId: string): Promise<Reminder | HttpError> {
        const res = await this.httpClient.get(`/reminder/${accountId}`)
        if (isError(res)) {
            return res as HttpError
        }
        const reminder = res as Reminder[]
        if (reminder.length > 0) {
            return reminder[0]
        }
        return res as Reminder
    }

    async RetrieveReminders(): Promise<Reminder[] | HttpError> {
        const res = await this.httpClient.get("/reminders")
        if (isError(res)) {
            return res as HttpError
        }
        return (res as Reminder[])
    }

    async CreateReminder(
        period: string,
        numberOfDays: number,
        subject: string,
        fromName: string,
        fromEmail: string,
        content: string,
        buttonLabel: string,
        includeAttachment: boolean,
    ): Promise<Reminder | HttpError> {
        const res = await this.httpClient.post("/reminders", {
            period: period,
            numberOfDays: numberOfDays,
            subject: subject,
            fromEmail: fromEmail,
            fromName: fromName,
            content: content,
            buttonLabel: buttonLabel,
            includeAttachment: includeAttachment,
        })
        if (isError(res)) {
            return res as HttpError
        }
        return (res as Reminder)
    }

    async UpdateReminder(
        reminderId: string,
        period: string,
        numberOfDays: number,
        subject: string,
        fromName: string,
        fromEmail: string,
        content: string,
        buttonLabel: string,
        includeAttachment: boolean,
    ): Promise<Reminder | HttpError> {
        const payload = {
            period: period,
            numberOfDays: numberOfDays,
            subject: subject,
            fromEmail: fromEmail,
            fromName: fromName,
            content: content,
            buttonLabel: buttonLabel,
            includeAttachment: includeAttachment,
        }
        const res = await this.httpClient.patch(`/reminders/${reminderId}`, payload)
        if (isError(res)) {
            return res as HttpError
        }
        return (res as Reminder)
    }

    async DeleteReminder(reminderId: string): Promise<Reminder | HttpError> {
        const res = await this.httpClient.delete(`/reminders/${reminderId}`)
        if (isError(res)) {
            return res as HttpError
        }
        return (res as Reminder)
    }
}

const instance = new ReminderService()
export default instance


// WEBPACK FOOTER //
// ./src/state/reminder/ReminderService.ts